export const CITIES = [
  // --- India: Metros & Tier 1 ---
  'Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad',
  // --- India: Tier 1-2 ---
  'Surat', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane', 'Bhopal',
  'Visakhapatnam', 'Patna', 'Vadodara', 'Ghaziabad', 'Ludhiana', 'Agra', 'Nashik',
  'Faridabad', 'Meerut', 'Rajkot', 'Varanasi', 'Srinagar', 'Aurangabad', 'Dhanbad',
  'Amritsar', 'Navi Mumbai', 'Allahabad', 'Howrah', 'Ranchi', 'Coimbatore', 'Jabalpur',
  'Gwalior', 'Vijayawada', 'Jodhpur', 'Madurai', 'Raipur', 'Kota', 'Chandigarh',
  'Guwahati', 'Solapur', 'Hubli-Dharwad', 'Tiruchirappalli', 'Bareilly', 'Mysuru',
  'Thiruvananthapuram', 'Tiruppur', 'Moradabad', 'Salem', 'Bhubaneswar', 'Warangal',
  // --- India: Jain-significant cities ---
  'Udaipur', 'Bikaner', 'Ajmer', 'Bhilwara', 'Ujjain', 'Palitana', 'Shatrunjaya',
  'Ranakpur', 'Jamnagar', 'Bhavnagar', 'Junagadh', 'Anand', 'Nadiad', 'Mehsana',
  'Patan', 'Gondal', 'Sangli', 'Kolhapur', 'Belgaum', 'Mangalore',
  // --- Rajasthan (expanded) ---
  'Alwar', 'Barmer', 'Beawar', 'Bundi', 'Chittorgarh', 'Churu', 'Dausa',
  'Dholpur', 'Dungarpur', 'Hanumangarh', 'Jaisalmer', 'Jhalawar', 'Jhunjhunu',
  'Kishangarh', 'Nagaur', 'Pali', 'Pratapgarh', 'Sawai Madhopur', 'Sikar',
  'Sri Ganganagar', 'Tonk',
  // --- Gujarat (expanded) ---
  'Amreli', 'Bharuch', 'Bhuj', 'Dahod', 'Deesa', 'Gandhidham', 'Godhra',
  'Halol', 'Himmatnagar', 'Jetpur', 'Kalol', 'Modasa', 'Morbi', 'Navsari',
  'Palanpur', 'Porbandar', 'Surendranagar', 'Valsad', 'Vapi', 'Veraval',
  'Gandhinagar',
  // --- Maharashtra (expanded) ---
  'Ahmednagar', 'Akola', 'Amravati', 'Chandrapur', 'Dhule', 'Ichalkaranji',
  'Jalgaon', 'Jalna', 'Latur', 'Malegaon', 'Nanded', 'Nandurbar', 'Osmanabad',
  'Parbhani', 'Ratnagiri', 'Satara', 'Wardha', 'Yavatmal',
  // --- Madhya Pradesh (expanded) ---
  'Burhanpur', 'Chhindwara', 'Damoh', 'Dewas', 'Guna', 'Hoshangabad',
  'Katni', 'Khandwa', 'Mandsaur', 'Morena', 'Neemuch', 'Ratlam', 'Rewa',
  'Sagar', 'Satna', 'Sehore', 'Shivpuri', 'Vidisha',
  // --- Karnataka (expanded) ---
  'Ballari', 'Bidar', 'Davangere', 'Gadag', 'Gulbarga', 'Hassan', 'Raichur',
  'Shimoga', 'Tumkur', 'Udupi',
  // --- Uttar Pradesh (expanded) ---
  'Aligarh', 'Ayodhya', 'Azamgarh', 'Ballia', 'Banda', 'Basti', 'Budaun',
  'Bulandshahr', 'Deoria', 'Etawah', 'Firozabad', 'Gorakhpur', 'Hardoi',
  'Jaunpur', 'Jhansi', 'Lakhimpur Kheri', 'Mathura', 'Mirzapur', 'Muzaffarnagar',
  'Noida', 'Greater Noida', 'Prayagraj', 'Raebareli', 'Rampur', 'Saharanpur',
  'Sambhal', 'Shahjahanpur', 'Sitapur', 'Sultanpur', 'Unnao',
  // --- Haryana ---
  'Gurugram', 'Panipat', 'Karnal', 'Ambala', 'Bhiwani', 'Hisar', 'Jhajjar',
  'Jind', 'Kaithal', 'Kurukshetra', 'Mahendragarh', 'Rewari', 'Rohtak',
  'Sirsa', 'Sonipat', 'Yamunanagar',
  // --- Punjab ---
  'Jalandhar', 'Bathinda', 'Patiala', 'Mohali', 'Hoshiarpur', 'Kapurthala',
  'Moga', 'Muktsar', 'Pathankot',
  // --- Bihar ---
  'Arrah', 'Bhagalpur', 'Bihar Sharif', 'Chapra', 'Darbhanga', 'Gaya',
  'Hajipur', 'Katihar', 'Motihari', 'Munger', 'Muzaffarpur', 'Purnia',
  'Samastipur', 'Sasaram',
  // --- Jharkhand ---
  'Jamshedpur', 'Bokaro', 'Deoghar', 'Giridih', 'Hazaribagh',
  // --- West Bengal ---
  'Siliguri', 'Durgapur', 'Asansol', 'Burdwan', 'Haldia', 'Kharagpur',
  'Malda', 'Kalyani',
  // --- Tamil Nadu (expanded) ---
  'Dindigul', 'Erode', 'Hosur', 'Kanchipuram', 'Karur', 'Nagercoil',
  'Namakkal', 'Thanjavur', 'Thoothukudi', 'Vellore',
  // --- Andhra Pradesh & Telangana ---
  'Guntur', 'Nellore', 'Kurnool', 'Tirupati', 'Kakinada', 'Rajahmundry',
  'Anantapur', 'Eluru', 'Kadapa', 'Ongole', 'Karimnagar', 'Khammam',
  'Mahbubnagar', 'Nizamabad', 'Siddipet',
  // --- Kerala ---
  'Kochi', 'Kozhikode', 'Thrissur', 'Kannur', 'Kollam', 'Alappuzha',
  'Palakkad', 'Malappuram',
  // --- Chhattisgarh ---
  'Bilaspur', 'Durg-Bhilai', 'Korba', 'Jagdalpur', 'Rajnandgaon', 'Ambikapur',
  // --- Odisha ---
  'Cuttack', 'Berhampur', 'Rourkela', 'Sambalpur', 'Balasore', 'Puri',
  // --- Uttarakhand ---
  'Dehradun', 'Haridwar', 'Haldwani', 'Roorkee', 'Rishikesh', 'Kashipur',
  // --- Himachal Pradesh ---
  'Shimla', 'Dharamshala', 'Mandi', 'Solan', 'Kullu',
  // --- Assam ---
  'Dibrugarh', 'Jorhat', 'Nagaon', 'Silchar', 'Tezpur', 'Tinsukia', 'Dispur',
  // --- Goa ---
  'Panaji', 'Margao', 'Vasco da Gama',
  // --- J&K and Ladakh ---
  'Jammu', 'Leh', 'Anantnag', 'Baramulla',
  // --- Northeast ---
  'Gangtok', 'Imphal', 'Shillong', 'Aizawl', 'Kohima', 'Agartala', 'Itanagar',
  'Dimapur',
  // --- Union Territories ---
  'Silvassa', 'Daman', 'Pondicherry', 'Port Blair',
  // --- International ---
  'London', 'Leicester', 'Birmingham', 'Manchester',
  'New York', 'Chicago', 'San Francisco', 'Los Angeles', 'Houston', 'Dallas', 'New Jersey',
  'Toronto', 'Vancouver', 'Calgary', 'Ottawa',
  'Melbourne', 'Sydney', 'Brisbane', 'Perth', 'Adelaide',
  'Singapore',
  'Dubai', 'Abu Dhabi', 'Sharjah',
  'Nairobi', 'Mombasa',
  'Hong Kong',
  'Kuala Lumpur',
  'Bangkok',
];

export const SECTS = [
  { value: 'Shvetambara', description: 'Follow the 8-day Paryushana' },
  { value: 'Digambara', description: 'Follow the 10-day Das Lakshana' },
  { value: 'Sthanakvasi', description: '' },
  { value: 'Terapanthi', description: '' },
  { value: 'Not sure / prefer not to say', description: '' },
];

export const DIET_PRACTICES = [
  'Full Jain vegetarian (no root vegetables, no eating after sunset)',
  'Jain vegetarian (no root vegetables, eat after sunset)',
  'Vegetarian (follow restrictions during Paryushana only)',
  'Prefer not to say',
];

export const PRACTICE_LEVELS = [
  { value: 'Devout', description: 'Daily practice, full festival observance' },
  { value: 'Moderate', description: 'Observe main festivals, Jain household' },
  { value: 'Cultural', description: 'Jain identity, flexible practice' },
];

export const LANGUAGES = ['Gujarati', 'Hindi', 'Marwari', 'Rajasthani', 'English', 'Other'];

export const GENERAL_PROMPTS = [
  'The way to my heart is...', 'I will never shut up about...',
  'My most controversial opinion is...', 'A perfect Sunday looks like...',
  "I'm looking for someone who...", 'Two truths and a lie about me',
  'My love language is...', 'The best trip I ever took was...',
  'I get way too competitive about...', "You should know I'm terrible at...",
  'My friends would describe me as...', 'The show I could rewatch forever',
  'The last thing that made me laugh out loud', "I'm a regular at...",
  'My simple pleasures are...',
];

export const JAIN_PROMPTS = [
  'The Jain principle I actually live by', 'My Paryushana survival strategy is...',
  'The food conversation I have on every first date',
  'My relationship with fasting is...',
  'I explain Jainism to non-Jains by saying...',
  'The most Jain thing about me that surprises people',
  'Ahimsa for me looks like ___ in real life',
  'The Jain value I want to pass on someday',
  'What being Jain means to me beyond the diet',
];

export const ALL_PROMPTS = [...GENERAL_PROMPTS, ...JAIN_PROMPTS];

export const RELATIONSHIP_INTENTS = [
  'Long term relationship', 'Short term', 'Open to see where it goes', 'Friends', 'Not sure yet',
];

export const GENDERS = ['Man', 'Woman', 'Non-binary'];
export const SEEKING_OPTIONS = ['Men', 'Women', 'Everyone'];

export const PARYUSHANA_DATES = {
  Shvetambara: { start: '2025-08-18', end: '2025-08-25' },
  Digambara: { start: '2025-08-18', end: '2025-08-27' },
};

export const FEET_OPTIONS = [4, 5, 6, 7];
export const INCHES_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export function cmToFeetInches(cm) {
  const total = Math.round(cm / 2.54);
  return { feet: Math.floor(total / 12), inches: total % 12 };
}

export function feetInchesToCm(feet, inches) {
  return Math.round((feet * 12 + inches) * 2.54);
}

export function formatHeight(cm) {
  if (!cm) return '';
  const locale = navigator.language || 'en-IN';
  if (locale.includes('IN') || locale.includes('hi')) return `${cm} cm`;
  const { feet, inches } = cmToFeetInches(cm);
  return `${feet}'${inches}"`;
}

export const PERSONALITY_TRAITS = {
  general: [
    'Curious', 'Analytical', 'Creative',
    'Empathetic', 'Ambitious', 'Grounded',
    'Spontaneous', 'Introverted', 'Extroverted',
    'Nurturing', 'Adventurous', 'Disciplined',
    'Humorous', 'Calm', 'Driven', 'Thoughtful'
  ],
  jain: [
    'Observant', 'Seva-minded', 'Sattvic',
    'Detached', 'Spiritually seeking',
    'Ahimsa-driven', 'Community-first',
    'Contemplative', 'Non-attached'
  ]
};

export const HOBBIES = {
  'Mind & spirit': [
    'Meditation', 'Yoga', 'Journaling',
    'Swadhyay', 'Temple visits', 'Puja'
  ],
  'Active & outdoors': [
    'Running', 'Gym', 'Cricket', 'Badminton',
    'Swimming', 'Dance'
  ],
  'Arts & making': [
    'Painting', 'Photography', 'Writing',
    'Music', 'Cooking', 'Rangoli'
  ],
  'Screens & stories': [
    'Films', 'Series', 'Documentaries',
    'Podcasts', 'Stand-up'
  ],
  'Exploring & travel': [
    'Hiking', 'Road trips', 'Backpacking',
    'Pilgrimage travel', 'Café hopping'
  ],
  'Home & slow living': [
    'Board games', 'Reading', 'Gardening',
    'Baking', 'Puzzles'
  ],
  'Digital & creating': [
    'Gaming', 'Content creation', 'Blogging',
    'Coding', 'Design'
  ],
  'Giving & community': [
    'Volunteering', 'Animal welfare',
    'Mentoring', 'Fundraising'
  ]
};

export const QUIZ_QUESTIONS = {

  relationship: [
    {
      key: 'rel_living',
      text: 'Where do you see yourself living in five years?',
      options: ['Same city, always', 'Open to relocating in India', 'Open to abroad', 'No strong preference']
    },
    {
      key: 'rel_wedding',
      text: 'How important is a grand traditional wedding to you?',
      options: ['Very — family and ritual matter', 'Jain Vidhi but simple', 'Court + small celebration', 'Whatever my partner prefers']
    },
    {
      key: 'rel_career',
      text: 'Your career vs family priority right now?',
      options: ['Career first', 'Both equally', 'Family first', 'Still figuring out']
    },
    {
      key: 'rel_conflict',
      text: 'When you disagree with a partner, you usually…',
      options: ['Address it immediately', 'Take a breather, then talk', 'Write it out first', 'Let it go if minor']
    },
    {
      key: 'rel_attachment',
      text: 'Your attachment style is closest to…',
      options: ['Secure — I communicate openly', 'Anxious — I need reassurance', 'Avoidant — I need space', 'Still figuring it out']
    },
    {
      key: 'rel_family',
      text: 'How close to family after marriage?',
      options: ['Joint family setup', 'Same city, separate home', 'Wherever life takes us', 'I need independence']
    },
    {
      key: 'rel_finances',
      text: 'Finances in a partnership should be…',
      options: ['Fully pooled', 'Shared expenses, separate savings', 'Fully separate', "We'd figure it out together"]
    },
    {
      key: 'rel_daan',
      text: 'How do you feel about donating to Jain trusts (daan)?',
      options: ['Non-negotiable priority', 'Yes, as finances allow', 'Occasionally', 'Prefer other causes']
    }
  ],

  friendship: [
    {
      key: 'fri_saturday',
      text: 'Ideal Saturday afternoon?',
      options: ['Temple + long lunch', 'Trekking or outdoors', 'Couch and a good show', 'Something spontaneous']
    },
    {
      key: 'fri_group',
      text: "In a group, you're usually…",
      options: ['The one organising everything', 'The quiet but reliable one', 'The comedian', 'The listener']
    },
    {
      key: 'fri_support',
      text: 'Your go-to way to support a friend going through something tough?',
      options: ['Show up with food', 'Long phone call', 'Give them space', 'Distract them with fun']
    },
    {
      key: 'fri_disagree',
      text: 'A friend vents about something you disagree with. You…',
      options: ['Listen first, always', 'Gently offer another view', 'Ask questions', 'Be honest, kindly']
    },
    {
      key: 'fri_identity',
      text: 'Your Jain identity in social settings feels…',
      options: ['Something I talk about openly', 'Personal, but not hidden', 'Complicated to explain', 'Just part of who I am']
    }
  ],

  open: [
    {
      key: 'open_weekend',
      text: 'How do you usually spend a long weekend?',
      options: ['Travel', 'Family time', 'Recharge at home', 'Mix of everything']
    },
    {
      key: 'open_aparigraha',
      text: 'What does aparigraha (non-possessiveness) mean to you personally?',
      options: ['Minimalist lifestyle', 'Not clinging emotionally', 'Charitable giving', 'Still exploring it']
    },
    {
      key: 'open_ambiguity',
      text: 'How comfortable are you with ambiguity in where a connection is heading?',
      options: ['Very — I enjoy the journey', 'Somewhat, with check-ins', 'I prefer clarity early', 'Depends on the person']
    },
    {
      key: 'open_connection',
      text: 'When you imagine a great connection, what matters most?',
      options: ['Deep conversations', 'Shared experiences', 'Emotional safety', 'Making each other laugh']
    },
    {
      key: 'open_faith',
      text: 'How important is shared faith practice in your closest relationships?',
      options: ['Very — it bonds us', 'Nice but not essential', 'I respect all paths', "I'm still working this out"]
    }
  ],

  bridge: [
    {
      key: 'bri_different',
      text: "If someone you're connecting with wants something different long-term, you…",
      options: ['Respect it and stay open', 'Need to understand their reasons', 'Find it hard to invest', 'Take it one conversation at a time']
    },
    {
      key: 'bri_communication',
      text: "What's your communication style by default?",
      options: ['Frequent, little updates', 'Deep but occasional', 'I match the other person', "I'm still learning my style"]
    },
    {
      key: 'bri_values',
      text: 'When your core values differ from someone you like, you usually…',
      options: ['Talk about it openly', 'Observe quietly for a while', 'Ask questions without judgment', 'Let the connection decide']
    },
    {
      key: 'bri_ahimsa',
      text: 'What does ahimsa look like in the way you treat people close to you?',
      options: ['Patience, always', 'Honesty without cruelty', 'Giving space when needed', 'It shows up differently each time']
    }
  ]

};

export function getQuizType(myIntent, theirIntent) {
  if (!myIntent || !theirIntent) return null;
  if (myIntent === 'relationship' && theirIntent === 'relationship') return 'relationship';
  if (myIntent === 'friendship' && theirIntent === 'friendship') return 'friendship';
  if (myIntent === 'open' || theirIntent === 'open') return 'open';
  return 'bridge';
}

export function calcAge(dob) {
  const today = new Date();
  const b = new Date(dob);
  let age = today.getFullYear() - b.getFullYear();
  const m = today.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < b.getDate())) age--;
  return age;
}
